import { csrfFetch } from '../utils/csrfFetch';
// Action Types
const LOAD_ACCOUNTS = "accounts/LOAD_ACCOUNTS";

// Action Creators
export const loadAccounts = (accounts) => ({
  type: LOAD_ACCOUNTS,
  payload: accounts,
});

// Thunks
export const fetchAccountsAdmin = () => async (dispatch) => {
  const response = await csrfFetch("/api/accounts");
  if (response.ok) {
    const accounts = await response.json();
    dispatch(loadAccounts(accounts));
  }
};

export const fetchAccountsUser = (accountId) => async (dispatch) => {
  try {
    const response = await csrfFetch('/api/accounts/');

    if (response.ok) {
      const accounts = await response.json();
      dispatch(loadAccounts(accounts));
      return accounts;
    } else {
      const error = await response.json();
      throw new Error(error.error || 'Failed to fetch accounts');
    }
  } catch (error) {
    console.error('Error fetching accounts:', error);
    throw error;
  }
};

export const fetchAccountById = (id) => async (dispatch) => {
  try {
    const response = await csrfFetch(`/api/accounts/${id}`);

    if (response.ok) {
      const account = await response.json();
      dispatch(loadAccounts([account]));
      return account;
    } else {
      const error = await response.json();
      throw new Error(error.error || 'Failed to fetch account');
    }
  } catch (error) {
    console.error('Error fetching account:', error);
    throw error;
  }
};

// Reducer
const initialState = [];

export default function accountsReducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_ACCOUNTS:
      return action.payload;
    case 'accounts/CLEAR_ACCOUNTS':
      return { ...state, list: [] };
    default:
      return state;
  }
}
